import Cookies from "js-cookie";
import moment from "moment";
import { AuthenticationResult } from "types/auth.types";

export const setToken = (AuthenticationResult: AuthenticationResult) => {
  if (AuthenticationResult) {
    const now = moment();
    const expiry = now.clone().add(30, "days");

    const cookieOptions = { expires: 30, path: "/" };

    Cookies.set(
      "thienkimlogisticsAccessToken",
      AuthenticationResult.accessToken,
      cookieOptions
    );

    if (AuthenticationResult.refreshToken) {
      Cookies.set(
        "thienkimlogisticsRefreshToken",
        AuthenticationResult.refreshToken,
        cookieOptions
      );
    }

    Cookies.set(
      "thienkimlogisticsLoginDate",
      now.format("YYYY-MM-DD HH:mm:ss"),
      cookieOptions
    );

    Cookies.set(
      "thienkimlogisticsExpiryDate",
      expiry.format("YYYY-MM-DD HH:mm:ss"),
      cookieOptions
    );

    Cookies.set(
      "thienkimlogisticsRemember",
      AuthenticationResult?.remember ? "true" : "false",
      cookieOptions
    );
  }
};

export const getAccessToken = (): string | undefined => {
  return Cookies.get("thienkimlogisticsAccessToken");
};

export const getRefreshToken = (): string | undefined => {
  return Cookies.get("thienkimlogisticsRefreshToken");
};

export const getRemember = (): boolean => {
  return Cookies.get("thienkimlogisticsRemember") === "true";
};

export const getAuthenticationResult = (): AuthenticationResult => {
  return {
    accessToken: Cookies.get("thienkimlogisticsAccessToken") ?? "",
    refreshToken: Cookies.get("thienkimlogisticsRefreshToken") ?? "",
    LoginDate: Cookies.get("thienkimlogisticsLoginDate") ?? "",
    ExpiryDate: Cookies.get("thienkimlogisticsExpiryDate") ?? "",
    remember: getRemember(),
  };
};

export const removeToken = () => {
  const cookieOptions = { path: "/" };

  Cookies.remove("thienkimlogisticsAccessToken", cookieOptions);
  Cookies.remove("thienkimlogisticsRefreshToken", cookieOptions);
  Cookies.remove("thienkimlogisticsLoginDate", cookieOptions);
  Cookies.remove("thienkimlogisticsExpiryDate", cookieOptions);
  Cookies.remove("thienkimlogisticsRemember", cookieOptions);
};
